enum ProjecfStageNameEnum {
  PROJECTSIGNUP = "Project Signup",
  DESIGNFINALIZATION = "Design Finalization",
  DESINSIGNOFF = "Design Sign Off",
  FACTORYDISPATCH = "Handover",
}
export default ProjecfStageNameEnum;
